import { defineComponent as _defineComponent } from 'vue'
import AdminNavigation from "../../AdminNavigationContainer.vue";
import { ref, onMounted, reactive, onUpdated, onBeforeUnmount } from "vue";
import NewsinfoDataService from "@/services/NewsinfoDataService";
import { useI18n } from "vue3-i18n";
import ResponseData from "@/types/ResponseData";
import Loading from "@/components/home/Loading.vue";
import Alert from "@/components/scan/parts/Alert.vue";
import { store } from "@/store/store";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const isLoading = ref(false);
const alertMessage = ref("");
const alertState = ref("");
const menuTitle = ref("News Maintenance");
const newsList = reactive([]);
const importanceList = reactive([]);
const modalTitle = ref("");
const buttonName = ref("");
const i18n = useI18n();
const isNoData = ref(false);
const destCode = ref("");
const isSendEmail = ref(false);

const selectedRowId = ref(0);
const subject = ref("");
const content = ref("");
const startdate = ref("");
const lastdate = ref("");
const todayDate = ref("");
const selectedImportance = ref("");
const deleteId = ref(0);
const subjectError = ref("");
const contentError = ref("");
const startDateError = ref("");
const endDateError = ref("");
const importanceError = ref("");

onMounted(async () => {
  window.addEventListener('resize', handleResize);
  isLoading.value = true;
  await Promise.all([
    getEditNews(),
    getImportanceList()
  ]);
  const today = new Date();
  todayDate.value = today.toISOString().split("T")[0];
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize);
});

function handleResize() {
  document.getElementById("startdate").min = todayDate.value;
  document.getElementById("lastdate").min = todayDate.value;

  try {
    var tableHeight = 0;
    var dataHeight = document.getElementById("tblNewsBody")?.clientHeight;
    if (dataHeight != 0) {
      tableHeight = document.getElementById("divNewsTable")?.clientHeight;
      if (dataHeight > tableHeight) {
        document.getElementById("divNewsTable").style.width = "80%";
      } else {
        document.getElementById("divNewsTable").style.width =
          "calc(80% - 16px)";
      }
    }
  } catch (e) {
    isLoading.value = false;
  }
}

onUpdated(() => {
  handleResize();
});

const getEditNews = async () => {
  isLoading.value = true;
  newsList.splice(0);
  destCode.value = store.getters.mainMenuCode;
  const data = { destCode: destCode.value };

  if (store.getters.showPage == "NewsEdit") {
    NewsinfoDataService.getEditNews(data).then((response: ResponseData) => {
      if (response.data.length != 0) {
        for (let info of response.data) {
          info["startDate"] = info["startDate"].substr(0, 10);
          info["lastDate"] = info["lastDate"].substr(0, 10);
          newsList.push(info);
        }
        isLoading.value = false;
      }else {
        isNoData.value = true;
      }
    });
  }
  isLoading.value = false;
};

const getImportanceList = () => {
  if(importanceList.length == 0){
    NewsinfoDataService.getImportanceList().then((response: ResponseData) => {
      if (response.data.length != 0) {
        for (let info of response.data) {
          importanceList.push(info);
        }
      }
      isLoading.value = false;
    });
  }
};

const onClickAddButton = () => {
  modalTitle.value = "Add news";
  buttonName.value = "Add";

  subject.value = "";
  content.value = "";
  startdate.value = "";
  lastdate.value = "";
  selectedImportance.value = "";
  clearErrorMsg();
};

const onClickEditButton = (id: any) => {
  modalTitle.value = "Edit news";
  buttonName.value = "Update";
  clearErrorMsg();
  const data = { id: id };

  NewsinfoDataService.getRowNews(data)
    .then((response: ResponseData) => {
      if (response.data.length != 0) {
        for (let info of response.data) {
          subject.value = info.Subject;
          content.value = info.Content;
          startdate.value = info.startDate.substr(0, 10);
          lastdate.value = info.lastDate.substr(0, 10);
          selectedImportance.value = info.importance.importance_id;
          selectedRowId.value = id;
        }
      } else {
        console.log("NO DATA");
      }
    })
    .catch((error: Error) => {
      console.log(error);
    });
};

const clearErrorMsg = () => {
  alertMessage.value = "null";
  alertState.value = "neutral";

  subjectError.value = "";
  contentError.value = "";
  startDateError.value = "";
  endDateError.value = "";
  importanceError.value = "";

  var chkId = document.getElementById("chkSendNewsEmail");
  if(chkId != undefined){
    chkId.checked = false;
    isSendEmail.value = false;
  }
}

const isInputOk = (inputData: any) => {
  clearErrorMsg();
  var isInputOk = true;
  if(inputData.Subject.trim() == ""){
    subjectError.value = i18n.t("alt044");
    isInputOk = false;
  }
  if(inputData.Content.trim() == ""){
    contentError.value = i18n.t("alt045");
    isInputOk = false;
  }
  if(inputData.startdate.trim() == ""){
    startDateError.value = i18n.t("alt046");
    isInputOk = false;
  }
  if(inputData.lastdate.trim() == ""){
    endDateError.value = i18n.t("alt047");
    isInputOk = false;
  }
  if(typeof(inputData.importanceid) == "string" && inputData.importanceid == ""){
    importanceError.value = i18n.t("alt048");
    isInputOk = false;
  }
  if(inputData.startdate.trim() != "" && inputData.lastdate.trim() != ""){
    var stDate = new Date(inputData.startdate);
    var lstDate = new Date(inputData.lastdate);
    if(stDate>lstDate){
      startDateError.value = i18n.t("alt079");
      isInputOk = false;
    }
  }
  return isInputOk;
}

const chkSendEmailChkChange = (event: { target: { value: any; }; }) => {
  isSendEmail.value = event.target.checked;
};

const AddOrUpdateNews = () => {
  var id = 0;
  if (buttonName.value == "Update") {
    id = selectedRowId.value;
  }
  const data = {
    id: id,
    Subject: subject.value,
    Content: content.value,
    startdate: startdate.value,
    lastdate: lastdate.value,
    importanceid: selectedImportance.value,
    isShowing: "1",
    destCode: store.getters.mainMenuCode,
    userId: store.getters.cognitoUserName,
    btnName: buttonName.value,
    isSendEmail: isSendEmail.value 
  };
  if(isInputOk(data)){
    isLoading.value = true;
    NewsinfoDataService.addorUpdateNews(data)
      .then((response: ResponseData) => {
        if (buttonName.value == "Add") {
          var insertedNews = response.data.newsData;
          insertedNews[0].startDate = insertedNews[0].startDate.substr(0, 10);
          insertedNews[0].lastDate = insertedNews[0].lastDate.substr(0, 10);
          newsList.push(insertedNews[0]);          
          newsList.sort(function (x, y) {
              let a = new Date(x.startDate),
                  b = new Date(y.startDate);
              return y.importance.importance_id - x.importance.importance_id || b - a;
          });

          alertMessage.value = i18n.t("suc023");
        } else {
          var updatedNews = response.data.newsData;
          const newNewsList = Array.from(newsList);
          newsList.splice(0);
          updatedNews[0]["startDate"] = updatedNews[0]["startDate"].substr(0, 10);
          updatedNews[0]["lastDate"] = updatedNews[0]["lastDate"].substr(0, 10);
          for(let newsObj of newNewsList){
            if(newsObj.id == updatedNews[0].id){
              newsList.push(updatedNews[0])
            }else{
              newsList.push(newsObj);
            }
          }
          newsList.sort(function (x, y) {
              let a = new Date(x.startDate),
                  b = new Date(y.startDate);
              return y.importance.importance_id - x.importance.importance_id || b - a;
          });
          alertMessage.value = i18n.t("suc015");
        }
        alertState.value = "success";
        isLoading.value = false;
      })
      .catch((error: Error) => {
        console.log(error);
        if (buttonName.value == "Add") {
          alertMessage.value = i18n.t("err027");
        } else {
          alertMessage.value = i18n.t("err028");
        }
        alertState.value = "error";
        isLoading.value = false;
      });
    document.getElementById("cancel")?.click();
  }else{
    return;
  }
};

const getDeleteId = (id: any) => {
  deleteId.value = id;
};

const deleteNews = () => {
  document.getElementById("deleteCancel")?.click();
  alertMessage.value = "null";
  alertState.value = "neutral";

  isLoading.value = true;
  const data = { id: deleteId.value };
  NewsinfoDataService.deleteNews(data)
    .then((_) => {
      var newNewsList = Array.from(newsList);
      newsList.splice(0);
      for(let newsObj of newNewsList){
        if(deleteId.value != newsObj.id){
          newsList.push(newsObj);
        }
      }

      alertMessage.value = i18n.t("suc018");
      alertState.value = "success";
      isLoading.value = false;
    })
    .catch((e: Error) => {
      console.log(e);
      alertMessage.value = i18n.t("err029");
      alertState.value = "error";
      isLoading.value = false;
    });
};

const __returned__ = { isLoading, alertMessage, alertState, menuTitle, newsList, importanceList, modalTitle, buttonName, i18n, isNoData, destCode, isSendEmail, selectedRowId, subject, content, startdate, lastdate, todayDate, selectedImportance, deleteId, subjectError, contentError, startDateError, endDateError, importanceError, handleResize, getEditNews, getImportanceList, onClickAddButton, onClickEditButton, clearErrorMsg, isInputOk, chkSendEmailChkChange, AddOrUpdateNews, getDeleteId, deleteNews, AdminNavigation, Loading, Alert, store }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})